export const getPostCode = (postCode: string) => {
  if (postCode.length === 8) {
    if (/-/.test(postCode)) {
      return postCode;
    }
  }

  if (postCode.length === 7) {
    return `${postCode.slice(0, 3)}-${postCode.slice(3)}`;
  }

  return '';
};
